module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-LightSemiCnIt.208a2f2.woff";